import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { importedNetworkRatecardAtom } from '../../store/jotai'

export function useImportedNetworkRatecard() {
  const [importWaitingToOpen, setImportWaitingToOpen] = useAtom(importedNetworkRatecardAtom)
  const [importedData, setImportedData] = useState(importWaitingToOpen)

  useEffect(() => {
    if (!importWaitingToOpen) return
    setImportedData(importWaitingToOpen)
    setImportWaitingToOpen(null)
  }, [importWaitingToOpen, setImportWaitingToOpen])

  return importedData
}
